import z from 'zod';
import { ERROR_MESSAGES } from '~/constants';
import {
  optionNumberSchemaRequired,
  optionSchema,
  optionSchemaRequired,
  requiredOptionSchema,
} from '~/features/types';

// [MCV-1665] The description is stored as sanitized HTML in a String(8192)
// column, so formatting shares the same budget as the visible text. Decision:
// keep the raw cap (client and column agree) and say so in the message, rather
// than widen the column in this change.
const DESCRIPTION_LIMIT_MESSAGE = 'Must be 8192 or less characters, including formatting';

export interface Context {
  loading: boolean;
}

export type OnAddEvent = {
  type: 'ON_ADD';
  payload: { values: BasicInfoFormValues };
};

export type OnUpdateEvent = {
  type: 'ON_UPDATE';
  payload: { values: BasicInfoFormValues };
};

export type Events = OnAddEvent | OnUpdateEvent;

export const BasicInfoFormSchema = z.object({
  id: z.number().optional(),
  jobTitle: z
    .string()
    .min(1, ERROR_MESSAGES.REQUIRED)
    .max(255, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(255)),
  jobDescription: z.string().max(8192, DESCRIPTION_LIMIT_MESSAGE),
  providerCategory: optionNumberSchemaRequired,
  // [MCV-1959] AI fit scoring skips a listing with no specialty, so every listing needs one.
  // The select is clearable (null), so the object itself carries the Required message too.
  aoiSpecialty: requiredOptionSchema(ERROR_MESSAGES.REQUIRED),
  subspecialties: z.array(optionSchema),
  generalSpecialtyFlag: z.boolean(),
  jobType: optionSchemaRequired,
  employmentClassification: optionSchemaRequired,
  workLocation: optionSchema,
});

export type Scope = {
  context: Context;
  event: Events;
};

export type BasicInfoFormValues = z.infer<typeof BasicInfoFormSchema>;
